module.exports = __webpack_public_path__ + "static/media/8900_Bedroom2.0f74c424.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_Bedroom2.jpg
// module id = 571
// module chunks = 0